import { ScaleDashboardSubTab } from '../../../graphql/types/dashboard/ScaleDashboardTypes';

/** 与 scale_dashboard_hourly_summary 表列对齐的维度字段 */
export interface ScaleDashboardDimensionFields {
    pickupHubId?: number | null;
    destHubId?: number | null;
    destWarehouseId?: number | null;
    pickupHubSortingCode?: string | null;
    destHubSortingCode?: string | null;
    destWarehouseSortingCode?: string | null;
}

/** 按 subTab 取主 HUB 列（pickup_hub_id 或 dest_hub_id） */
export function scaleItemHubId(
    item: ScaleDashboardDimensionFields,
    subTab?: ScaleDashboardSubTab,
): number {
    if (subTab === ScaleDashboardSubTab.PICKUP_ORDER || subTab === ScaleDashboardSubTab.PICKUP_TREND) {
        return Number(item.pickupHubId ?? 0);
    }
    return Number(item.destHubId ?? 0);
}

export function scaleItemSortingCode(
    item: ScaleDashboardDimensionFields,
    subTab?: ScaleDashboardSubTab,
): string {
    if (subTab === ScaleDashboardSubTab.PICKUP_ORDER || subTab === ScaleDashboardSubTab.PICKUP_TREND) {
        return (item.pickupHubSortingCode ?? '').trim();
    }
    return (item.destHubSortingCode ?? '').trim();
}
